import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=6de1b0ce&scoped=true&"
var script = {}
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=6de1b0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de1b0ce",
  null
  
)

export default component.exports